<template>
  <div id="app">
    <WebClock />
  </div>
</template>

<script>
import WebClock from "./components/WebClock.vue";

export default {
  name: "App",
  components: {
    WebClock,
  },
};
</script>

<style>
body {
  overflow: hidden;
  background-color: black;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  background-color: black;
}
</style>
